import { setting } from "nprogress";
import { store } from "./store";
import { products } from "./api/products/data";

export const paths = {
  index: '/',
  checkout: '/checkout',
  contact: '/dashboard/contact',
  pricing: '/pricing',
  auth: {
    auth0: {
      callback: '/auth/auth0/callback',
      login: '/auth/auth0/login'
    },
    jwt: {
      login: '/auth/jwt/login',
      register: '/auth/jwt/register'
    },
    firebase: {
      login: '/auth/firebase/login',
      register: '/auth/firebase/register'
    },
    amplify: {
      confirmRegister: '/auth/amplify/confirm-register',
      forgotPassword: '/auth/amplify/forgot-password',
      login: '/auth/amplify/login',
      register: '/auth/amplify/register',
      resetPassword: '/auth/amplify/reset-password'
    }
  },
  authDemo: {
    forgotPassword: {
      classic: '/auth-demo/forgot-password/classic',
      modern: '/auth-demo/forgot-password/modern'
    },
    login: {
      classic: '/auth-demo/login/classic',
      modern: '/auth-demo/login/modern'
    },
    register: {
      classic: '/auth-demo/register/classic',
      modern: '/auth-demo/register/modern'
    },
    resetPassword: {
      classic: '/auth-demo/reset-password/classic',
      modern: '/auth-demo/reset-password/modern'
    },
    verifyCode: {
      classic: '/auth-demo/verify-code/classic',
      modern: '/auth-demo/verify-code/modern'
    }
  },

  setting: {
    index: '/setting',
    account: '/setting/account',
    sysMenu: { 
      sysMenuList: '/setting/sysMenu',
      createSysMenu: '/setting/sysMenu/createSysMenu',
    },
    sysTranslate: { 
      translateList: '/setting/sysTranslate',
      createTranslate: '/setting/sysTranslate/createTranslate',
    },
    user: { 
      userList: '/setting/user',
      createUser: '/setting/user/createUser',
    },
    store: {
      storeList: '/setting/store',
      createStore: '/setting/store/createStore',
    },
    location: {
      locationList: '/setting/location',
      createLocation: '/setting/location/createLocation',
    },
    paymentType: {
      paymentTypeList: '/setting/paymentType',
      createPaymentType: '/setting/paymentType/createPaymentType',
    },
    country: {
      index: '/setting/country',
      createCountry: '/setting/country/createCountry'
    },
    region: {
      regionList: '/setting/region',
      createRegion: '/setting/region/createRegion',
    },
    tax: {
      taxList: '/setting/tax',
      createTax: '/setting/tax/createTax',
    },
    expensesType: {
      expensesTypeList: '/setting/expensesType',
      createExpensesType: '/setting/expensesType/createExpensesType',
    },
    receivedType: {
      receivedTypeList: '/setting/receivedType',
      createReceivedType: '/setting/receivedType/createReceivedType',
    },
    loyaltyPoint: {
      loyaltyPointList: '/setting/loyaltyPoint',
      createLoyaltyPoint: '/setting/loyaltyPoint/createLoyaltyPoint',
    },
    giftCard: {
      giftCardList: '/setting/giftCard',
      createGiftCard: '/setting/giftCard/createGiftCard',
    },
    discount: {
      discountList: '/setting/discount',
      createDiscount: '/setting/discount/createDiscount',
    },
    invoices: {
      index: '/setting/invoices',
      details: '/setting/invoices/:orderId'
    },
    orders: {
      index: '/setting/orders',
      details: '/setting/orders/:orderId'
    },
  },

  //inventory
  inv: {
    index: '/inv',
    itemCategory: {
      itemCategoryList: '/inv/itemCategory',
      createItemCategory: '/inv/itemCategory/createItemCategory',
    },
    unit: {
      unitList: '/inv/unit',
      createUnit: '/inv/unit/createUnit',
    },
    attributes: {
      attributesList: '/inv/attributes',
      createAttributes: '/inv/attributes/createAttributes',
    },
    product: {
      productList: '/inv/product',
      createProduct: '/inv/product/createProduct',
      myCarts: '/inv/product/myCarts',
      orderSummery: '/inv/product/orderSummery',
    },
    floor: {
      floorList: '/inv/floor',
      createFloor: '/inv/floor/createFloor',
    },
    item: {
      itemList: '/inv/item',
      createItem: '/inv/item/createItem',
    },
    promotionReward: {
      promotionRewardList: '/inv/promotionReward',
      createPromotionReward: '/inv/promotionReward/createPromotionReward',
    },
    loyaltyPointReward: {
      loyaltyPointRewardList: '/inv/loyaltyPointReward',
      createLoyaltyPointReward: '/inv/loyaltyPointReward/createLoyaltyPointReward',
    },


    //Customer

    customerCategory: {
      customerCategoryList: '/inv/customerCategory',
      createCustomerCategory: '/inv/customerCategory/createCustomerCategory',
    },
    customer: {
      customerList: '/inv/customer',
      createCustomer: '/inv/customer/createCustomer',
    },
    custGiftCard: {
      custGiftCardList: '/inv/custGiftCard',
      createCustGiftCard: '/inv/custGiftCard/createCustGiftCard',
    },
    salesReports: {
      salesByDay: '/inv/salesReports',
      salesByMenu: '/inv/salesReports/salesByMenu',
      salesByPaymentType: '/inv/salesReports/salesByPaymentType',
      salesByCategory: '/inv/salesReports/salesByCategory',
      salesByInvoice: '/inv/salesReports/salesByInvoice',
      salesByCustomer: '/inv/salesReports/salesByCustomer',
      salesByCashier: '/inv/salesReports/salesByCashier',
      salesByDineIn: '/inv/salesReports/salesByDineIn',
      cashierInOutReports: '/inv/salesReports/cashierInOutReports',
      invoiceDetails: '/inv/salesReports/invoiceDetails',
    },

    fileManager: '/inv/file-manager',
  },

  dashboard: {
    index: '/dashboard',
    contact: '/dashboard/contact',
    account: '/dashboard/account',
    customers: {
      index: '/dashboard/customers',
      details: '/dashboard/customers/:customerId',
      edit: '/dashboard/customers/:customerId/edit'
    },
    products: {
      index: '/dashboard/products'
    },
    invoices: {
      index: '/dashboard/invoices',
      details: '/dashboard/invoices/:invoiceId'
    },
    orders: {
      index: '/dashboard/orders',
      details: '/dashboard/orders/:orderId'
    }
  },

  components: {
    index: '/components',
    dataDisplay: {
      detailLists: '/components/data-display/detail-lists',
      tables: '/components/data-display/tables',
      quickStats: '/components/data-display/quick-stats'
    },
    lists: {
      groupedLists: '/components/lists/grouped-lists',
      gridLists: '/components/lists/grid-lists'
    },
    forms: '/components/forms',
    modals: '/components/modals',
    charts: '/components/charts',
    buttons: '/components/buttons',
    typography: '/components/typography',
    colors: '/components/colors',
    inputs: '/components/inputs'
  },

  docs: 'https://material-kit-pro-react-docs.devias.io',
  notAuthorized: '/401',
  notFound: '/404',
  serverError: '/500'
};
  